import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SportsCricketIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sports_cricket"}/>
}
